import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import permission from '~/skills/permission';
import {
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';

import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import { S_Input, S_Btn_Search, S_Btn_Add, S_Select, S_Title } from '~/components/SearchItem';

import T_common from '~/components/TableItem/common';
import CheckDelete from '~/components/Dialog/CheckDelete';

class FanList extends Component {
  state={
    keyword: '',

    per_page: 10,
    page: 1,

    sort: true,
    sort_field: 'upd_time',
    view_checkDelete: false,
    view_addAndEdit: false,
    mode_addAndEdit: '',
    currentId: '',
    currentAct: '',
  }

  componentDidMount () {
    // const { status, keyword, org_id } = this.state;
    // this.data = { status, keyword, org_id };
    this.refresh();
  }

  componentDidUpdate (preProps) {
    const { doRefresh: preDoRefresh = false } = preProps;
    const { doRefresh = false } = this.props;
    if (doRefresh && (doRefresh !== preDoRefresh)) {
      this.refresh();
    }
  }

  refresh=() => {
    const { getPPFanList, handleFanData } = this.props;
    const { page, per_page, sort, sort_field } = this.state;
    // const { status, keyword, org_id } = this.data;
    getPPFanList({
      page,
      per_page,
      body: {
        // keyword,
        // org_id: org_id === '0' ? '' : org_id,
        sort: sort ? 'desc' : 'asc',
        sort_field,
      },
    });
    handleFanData({ doRefresh: false });
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());

  _click_search=() => {
    // const { status, keyword, org_id, sort, sort_field } = this.state;
    // this.data = { status, keyword, org_id, sort, sort_field };
    this.search();
  }

  _delete=(id, act) => this.setState({ currentId: id, currentAct: act, view_checkDelete: true })
  _close_view_checkDelete=() => {
    this.refresh();
    this.setState({ currentId: '', currentAct: '', view_checkDelete: false });
  }

  // _add=() => this.setState({ view_addAndEdit: true, mode_addAndEdit: 'add' })
  _add=() => this.props.handleFanData({ id: '', open: true, mode: 'add' })
  // _view=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'view' })
  _view=id => this.props.handleFanData({ id, open: true, mode: 'view' })
  // _edit=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'edit' })
  _edit=id => this.props.handleFanData({ id, open: true, mode: 'edit' })
  _close_view_addAndEdit=() => {
    this.refresh();
    this.setState({ currentId: '', view_addAndEdit: false, mode_addAndEdit: '' });
  }

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '序號' },
      { name: '風機編號', id: 'fan_point' },
      { name: '工進項目階段' },
      { name: '水深', id: 'wathch_depth' },
      { name: '抵台與否' },
      { name: '預計完成日' },
      { name: '實際完成日' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { PPFanList = {}, canEdit, canDel, sign: { role_level = 1 } = {} } = this.props;
    const { list = [], page = 0, total = 0, per_page = 0 } = PPFanList;
    const cellStyle = { fontSize: 14 };

    const checkCanEdit = (form_status, admin_status) => {
      const formStatus = Number(form_status);
      const adminStatus = Number(admin_status);
      const roleLevel = Number(role_level);
    
      if (!canEdit) return false;
    
      switch (roleLevel) {
        case 1:
          return formStatus < 2;
    
        case 2:
          return formStatus >= 2 && formStatus < 3;
    
        case 3:
          return formStatus === 3 && adminStatus === 1;
    
        default:
          return false;
      }
    };

    let start = 0;
    if (page > 0) {
      start = (page - 1) * per_page + 1;
      if (start > total)start = 0;
    }

    return (
      <TableBody>
        {list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + start}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.fan_point}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.b}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.wathch_depth}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.d}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.e}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.f}</TableCell>
            <TableCell style={{ width: 214 }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <T_Btn_Function text='檢視' backgroundColor={T_common.type1} onClick={() => this._view(o.id)} />
                {
                  checkCanEdit(o.form_status, o.admin_status) &&
                  <T_Btn_Function text='編輯' backgroundColor={T_common.type2} onClick={() => this._edit(o.id)} style={{ marginLeft: 8, marginRight: 8 }} disabled={!checkCanEdit(o.form_status, o.admin_status)} />
                }
                {
                  !checkCanEdit(o.form_status, o.admin_status) && <div style={{ marginLeft: 5, marginRight: 5 }}></div>
                }
                {
                  canDel &&
                  <T_Btn_Function text='刪除' backgroundColor={T_common.type3} onClick={() => this._delete(o.id, o.fan_point)} disabled={!canDel} />
                }
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { PPFanList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = PPFanList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [10, 20, 30, 40];
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { PPFanList = {} } = this.props;
    const { list = [] } = PPFanList;
    const haveData = list.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  render () {
    const { deletePPFan, PPFanList = {}, canAdd } = this.props;
    const { currentId, view_checkDelete, currentAct } = this.state;
    const { list = [] } = PPFanList;
    const haveData = list.length > 0;
    return (
      <div style={{ width: '100%' }}>
        <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
          <div style={{ color: '#064B6F', fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%' }}>風機點位清單</div>
          <S_Btn_Add onClick={this._add} style={{ marginLeft: 24 }} disabled={!canAdd} />
        </div>
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        <CheckDelete
          open={view_checkDelete}
          text={`風機編號：${currentAct}`}
          onClose={this._close_view_checkDelete}
          search={this.search}
          resKey='DeletePPFan'
          onDelete={() => { deletePPFan(currentId); }}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  sign: state.data.AtyFunction,
  PPFanList: state.data.PPFanList,
  ...permission.returnPermission(state),
});
const mapDispatchToProps = dispatch => ({
  getPPFanList: body => Actions_Wind.getPPFanList(dispatch, body),
  deletePPFan: id => Actions_Wind.deletePPFan(dispatch, { id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(FanList);
